<template>
    <button class="ring-button" :class="mainClass" @click="$emit('click', $event)">
        <div class="ring-button-content">
            <slot></slot>
        </div>
    </button>
</template>

<script>

export default {
    props: {
        responsive: {
            default: true,
            type: Boolean
        }
    },
    data() {
        return {
        }
    },
    computed: {
        mainClass () {
            return this.responsive ? 'responsive' : ''
        }
    },
    methods: {
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">
@import "~assets/v3/css/variables.styl";

.ring-button
    width 40px
    height 40px
    padding 0
    border 0

    .ring-button-content
        width 100%
        height 100%
        padding 0
        overflow hidden
        position relative
        background-color #0282E5
        text-transform uppercase
        border-radius 100px
        font-weight bold
        color #ffffff
        cursor pointer
        transition box-shadow 0.35s, background 0.35s, color 0.35s, transform 0.5s cubic-bezier(0.270, 1.650, 0.500, 1.000)
        box-sizing border-box
        display flex
        justify-content center
        align-items center

        &.responsive
            responsive-styling(max-width, 140, 280, 400, 800)
            responsive-styling(font-size, 12, 18, 400, 800)
            // responsive-styling(padding, 6, 12, 400, 800)

        .hover-bounce
            transition transform 0.5s cubic-bezier(0.270, 1.650, 0.500, 1.000)

        &:hover
            box-shadow 0 2px 8px rgba(0, 0, 0, 0.4)
            transform scale(1.1)
            background-color lighten(#0282E5, 15)
            z-index 10

            .hover-bounce
                animation hover-bounce-anim 0.6s infinite
                animation-timing-function ease-in-out

                @keyframes hover-bounce-anim
                    0%
                        transform translateY(-2px)
                    50%
                        transform translateY(2px)
                    100%
                        transform translateY(-2px)

        &:active
            background-color lighten(#0282E5, 30)

        .cv-icon
            font-size 18px
            transform translate(0, -2px)
            transition all 0.25s
</style>



// WEBPACK FOOTER //
// src/components/v3/buttons/RingButton.vue